// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  name: 'local',
    //  apiRoot: 'https://vmsapiuat.devcare.com/api/',
    // authRoot: 'https://vmsapiuat.devcare.com/api/auth/',
  //  apiRoot: 'http://vmsdevtestapi.devcare.com:9090/api/',
  //  authRoot: 'http://vmsdevtestapi.devcare.com:9090/api/auth/',
  //   apiRoot: 'https://vmsapibdt.devcare.com/api/',
  // authRoot: 'https://vmsapibdt.devcare.com/api/auth/',
  // apiRoot: 'https://localhost:44359/api/',
  // authRoot: 'https://localhost:44359/api/auth/',
  apiRoot: 'https://dvmsapi.devcare.com/api/',
  authRoot: 'https://dvmsapi.devcare.com/api/auth/',
   dropboxKey : '83xtbdcka1jk6m8',
   oneDriveClientId: 'ab52f262-10ef-40cd-ac66-56db66565a91',
    downloadUrl: 'https://dvmsprod.blob.core.windows.net/',
   gDriveClientId:'41336814423-anid9ur57mqk50fmksifqru4lib2nqu0.apps.googleusercontent.com',
  gDriveApiKey:'AIzaSyCK2cqjq1aPIzzdqC6cKhPHfsGtlik2GF4',
  gDriveAppId: 'dvms-dev',
  inActiveSeconds : 600,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
